import { jsx as _jsx } from "react/jsx-runtime";
import { ICONS } from '@app/styles';
import { Component_SL_Icon } from '@app/styles/skeleton-loaders';
import { AwaitModules, ComponentSync, openContent } from '@nu-art/thunderstorm-frontend';
import { iconTooltipId } from '../../../_style/icon-tooltip/index.js';
import { ModuleFE_Spotlight } from '../../../../modules/ModuleFE_Spotlight/ModuleFE_Spotlight.js';
import { ModuleFE_Advisor_AdvisorWizard } from '@app/advisor-frontend';
const modulesToAwait = [ModuleFE_Advisor_AdvisorWizard];
class Component_WizardIcon_Class extends ComponentSync {
    //######################### Life Cycle #########################
    deriveStateFromProps(props, state) {
        state.tooltipContent = props.tooltipContent;
        state.wizard ??= ModuleFE_Advisor_AdvisorWizard.cache.find(props.wizardFilter);
        return state;
    }
    //######################### Logic #########################
    onClick = () => {
        const wizardId = this.state.wizard?._id;
        if (!wizardId)
            return;
        ModuleFE_Spotlight.openWizard({ wizardId });
    };
    getTooltipProps = () => {
        if (!this.state.tooltipContent)
            return {};
        return openContent.tooltip.left(iconTooltipId, this.state.tooltipContent, { offset: 8 });
    };
    //######################### Render #########################
    render() {
        if (!this.state.wizard)
            return;
        return _jsx(ICONS.advisor_v5_freeText.component, { ...this.getTooltipProps(), onClick: this.onClick });
    }
}
export const Component_WizardIcon = (p) => _jsx(AwaitModules, { modules: modulesToAwait, Component: () => _jsx(Component_WizardIcon_Class, { ...p }), customLoader: _jsx(Component_SL_Icon, { variant: 'square' }) });
//# sourceMappingURL=Component_WizardIcon.js.map